import { Grid2 as Grid } from "@mui/material";

import GroupIcon from '@mui/icons-material/Group';
import BarChartIcon from '@mui/icons-material/BarChart';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';

import AccountTreeIcon from '@mui/icons-material/AccountTree';
import StoreIcon from '@mui/icons-material/Store';
import PersonIcon from '@mui/icons-material/Person';

import { BarChart, SummaryCard, UsageCard, PieChart } from "@shared/components";
import { UsersRankingCard } from "@modules/dashboard/components";

import { useDashboard } from "./controller";

export function Dashboard() {
  const { data } = useDashboard();

  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 4 }}>
        <SummaryCard
          icon={<GroupIcon />}
          label="Conveniados"
          value={data?.users?.all?.toLocaleString() || "0"}
        />
      </Grid>

      <Grid size={{ xs: 4 }}>
        <SummaryCard
          icon={<BarChartIcon />}
          label="Utilizações"
          value={data?.usage?.all?.toLocaleString() || "0"}
        />
      </Grid>

      <Grid size={{ xs: 4 }}>
        <SummaryCard
          icon={<AttachMoneyIcon />}
          label="Economizado"
          value={`R$ ${data?.usage?.total_estimated_saved?.toLocaleString("pt-BR", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }) || "0,00"}`}
        />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <BarChart
          title="Usuários x Utilizações por Mês"
          xAxis={[
            {
              scaleType: 'band',
              data: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
            },
          ]}
          series={[
            {
              label: 'Novos Usuários',
              data: data?.users.activated_monthly_count || [],
            },
            {
              label: 'Utilizações',
              data: data?.usage.monthly_count || [],
            },
          ]}
          height={350}
        />
      </Grid>

      <Grid size={{ xs: 4 }}>
        <UsageCard
          icon={<AccountTreeIcon />}
          label="Utilizações E-Commerce"
          value={data?.usage.online.toLocaleString() || "0"}
        />
      </Grid>

      <Grid size={{ xs: 4 }}>
        <UsageCard
          icon={<StoreIcon />}
          label="Utilizações Físicas"
          value={data?.usage.local.toLocaleString() || "0"}
        />
      </Grid>

      <Grid size={{ xs: 4 }}>
        <UsageCard
          icon={<PersonIcon />}
          label="Utilizações por Usuário"
          value={data?.usage.usage_per_user.toFixed(2) || "0"}
        />
      </Grid>

      <Grid size={{ xs: 7 }}>
        <BarChart
          title="Utilização x Dia da Semana"
          xAxis={[
            {
              scaleType: 'band',
              data: data?.usage.week_day_usage.map((day) => {
                const days = ["Domingo", "Segunda", "Terça", "Quarta", "Quinta", "Sexta", "Sábado"];
                return days[day.created_at__week_day - 1];
              }) || [],
            },
          ]}
          series={[
            {
              data: data?.usage.week_day_usage.map((day) => day.usage) || [],
            },
          ]}
          height={350}
        />
      </Grid>

      <Grid size={{ xs: 5 }}>
       <PieChart
          title="Utilização por Categoria"
          data={
            data?.usage.category_usage.map(([label, value], index) => ({
              id: index,
              value,
              label,
            })) || []
          }
          slotProps={{
            legend: {
              hidden: true,
            },
          }}
          height={300}
        />
      </Grid>

      <Grid size={{ xs: 7 }}>
        <BarChart
          title="Ranking Lojas"
          yAxis={[
            {
              scaleType: 'band',
              data: data?.usage.total_highest_usage.map(
                (item) => item.discount__company__name
              ) || [],
              tickLabelStyle: {
                fontSize: 10,
              },
            },
          ]}
          series={[
            {
              data: data?.usage.total_highest_usage.map(
                (item) => item.discount__count
              ) || [],
            },
          ]}
          layout="horizontal"
          height={350}
        />
      </Grid>

      <Grid size={{ xs: 5 }}>
        <UsersRankingCard
          title="Ranking Usuários"
          data={
            data?.usage.highest_user_usage.map(([id, name, usageCount, photo]) => ({
              id,
              full_name: name,
              image: photo,
              usage: usageCount,
            })) || []
          }
        />
      </Grid>
    </Grid>
  )
}
